// ── PLATFORM ADAPTER (web) ────────────────────────────────────────────────────
// Uses navigator.geolocation. The RN port swaps THIS FILE for expo-location behind
// the same `getCurrentPosition(): Promise<{lat,lon}>` signature — callers don't change.

/** Promise wrapper over the Geolocation API with sane defaults. */
export function getCurrentPosition(
  opts: PositionOptions = { enableHighAccuracy: false, timeout: 10_000, maximumAge: 5 * 60_000 },
): Promise<{ lat: number; lon: number }> {
  return new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject(new Error('Geolocation is not available on this device.'))
      return
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }),
      (err) => reject(geoError(err)),
      opts,
    )
  })
}

function geoError(err: GeolocationPositionError): Error {
  switch (err.code) {
    case err.PERMISSION_DENIED:
      return new Error('Location permission denied. Search for a place instead.')
    case err.POSITION_UNAVAILABLE:
      return new Error('Could not determine your location.')
    case err.TIMEOUT:
      return new Error('Locating timed out. Try again.')
    default:
      return new Error('Location error.')
  }
}

/** A sensible US default so the app is never empty on first run (NWS HQ, Silver Spring MD). */
export const DEFAULT_LOCATION = { lat: 38.9913, lon: -77.0261, label: 'Silver Spring, MD' }
